/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Ready
 *
 * 1 = NotReady
 */
export enum LoanCarConditionStatus {
  Ready = 0,
  NotReady = 1,
}
